export type ModuleId = 'overview' | 'sales' | 'customer' | 'marketing' | 'inventory' | 'operations' | 'metrics'

export type WorkspaceModule = {
  id: ModuleId
  label: string
  path: string | null
  status: 'available' | 'planned'
}

export const workspaceModules: WorkspaceModule[] = [
  { id: 'overview', label: 'Overview', path: '/analytics/overview', status: 'available' },
  { id: 'sales', label: 'Sales', path: '/analytics/sales', status: 'available' },
  { id: 'customer', label: 'Customer', path: '/analytics/customer', status: 'available' },
  { id: 'marketing', label: 'Marketing', path: '/analytics/marketing', status: 'available' },
  { id: 'inventory', label: 'Inventory', path: '/analytics/inventory', status: 'available' },
  { id: 'operations', label: 'Operations', path: '/analytics/operations', status: 'available' },
  { id: 'metrics', label: 'Metrics', path: '/analytics/metrics', status: 'available' },
]
